// ==================== CONST DATA START ==================== //

// Project Name
export const PROJECT_NAME = "The Bharatiya Vidya";
export const CREATOR_NAME = "AW Digital Support";
export const CREATOR_LINK = "https://www.awdigitalsupport.com";
export const CURRENCY = "₹";
export const THEME = "d9534f";
export const SECONDARY_THEME = "C19FB3";
// Pusher use for notification
export const PUSHER_APP_KEY = "18eb8193262ee1f34d24";
export const PUSHER_APP_CLUSTER = "ap2";

// ==================== CONST DATA END ==================== //
export const USER_TYPE = [
  {
    value: "admin",
    label: "Admin",
  },
  {
    value: "reception",
    label: "Reception",
  },
  {
    value: "Biller",
    label: "Biller",
  },
];

// Function to get the label for a user_type value
export const getUserTypeLabel = (userType) => {
  // Find the matching user type in the USER_TYPE array
  const userTypeObj = USER_TYPE.find((type) => type.value === userType);

  // If a match is found, return the label, otherwise return a default value
  return userTypeObj ? userTypeObj.label : "Unknown User Type";
};
